import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X, MessageSquare } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navLinkStyles = ({ isActive }) => 
    `relative px-1 py-2 text-xs sm:text-sm font-medium tracking-wide text-prose-black transition-colors duration-300 ${
      isActive ? 'text-prose-brand font-bold' : 'hover:text-prose-brand'
    }
    after:absolute after:bottom-0 after:left-0 after:h-0.5 after:rounded-full after:transition-all after:duration-300 ${
      isActive 
        ? 'after:w-full after:bg-prose-gold' 
        : 'after:w-0 after:bg-prose-gold hover:after:w-full'
    }`;

  return (
    <nav className="fixed w-full z-50 bg-white/95 backdrop-blur-md border-b border-gray-100 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <NavLink 
          to="/" 
          className="flex items-center gap-2.5 group transition-transform duration-300 hover:scale-105 flex-shrink-0"
        >
          <img 
            src="/images/logos/Fade no bg.png" 
            alt="ProjectProse" 
            className="w-10 h-10 group-hover:rotate-6 transition-transform duration-300"
            loading="eager"
          />
          <span className="font-display font-bold text-sm sm:text-base tracking-tight text-prose-black">ProjectProse</span>
        </NavLink>

        <div className="hidden lg:flex items-center justify-center flex-1">
          <div className="flex gap-8">
            <NavLink to="/" className={navLinkStyles}>Home</NavLink>
            <NavLink to="/about" className={navLinkStyles}>About</NavLink>
            <NavLink to="/services" className={navLinkStyles}>Services</NavLink>
            <NavLink to="/properties" className={navLinkStyles}>Properties</NavLink>
            <NavLink to="/contact" className={navLinkStyles}>Contact</NavLink>
          </div>
        </div>

        <div className="flex items-center gap-4">
          <NavLink 
            to="/contact"
            className="hidden lg:flex items-center gap-2 px-5 py-2 bg-prose-brand text-white rounded-lg font-medium text-sm tracking-wide hover:bg-prose-brand/90 transition-all duration-300 hover:translate-y-[-2px] active:translate-y-0 flex-shrink-0"
          >
            <MessageSquare size={17} />
            Get in Touch
          </NavLink>

          <button 
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 text-prose-black"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} strokeWidth={2.5} /> : <Menu size={24} strokeWidth={2.5} />}
          </button>
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-100 animate-in fade-in slide-in-from-top-2 duration-300">
          <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
            <NavLink 
              onClick={() => setIsOpen(false)} 
              to="/" 
              className={({ isActive }) => `px-4 py-3 rounded-lg font-medium text-sm tracking-wide transition-all duration-200 ${
                isActive 
                  ? 'bg-prose-brand/10 text-prose-brand font-bold' 
                  : 'text-prose-black hover:bg-gray-50'
              }`}
            >
              Home
            </NavLink>
            <NavLink 
              onClick={() => setIsOpen(false)} 
              to="/about" 
              className={({ isActive }) => `px-4 py-3 rounded-lg font-medium text-sm tracking-wide transition-all duration-200 ${
                isActive 
                  ? 'bg-prose-brand/10 text-prose-brand font-bold' 
                  : 'text-prose-black hover:bg-gray-50'
              }`}
            >
              About
            </NavLink>
            <NavLink 
              onClick={() => setIsOpen(false)} 
              to="/services" 
              className={({ isActive }) => `px-4 py-3 rounded-lg font-medium text-sm tracking-wide transition-all duration-200 ${
                isActive 
                  ? 'bg-prose-brand/10 text-prose-brand font-bold' 
                  : 'text-prose-black hover:bg-gray-50'
              }`}
            >
              Services
            </NavLink>
            <NavLink 
              onClick={() => setIsOpen(false)} 
              to="/properties" 
              className={({ isActive }) => `px-4 py-3 rounded-lg font-medium text-sm tracking-wide transition-all duration-200 ${
                isActive 
                  ? 'bg-prose-brand/10 text-prose-brand font-bold' 
                  : 'text-prose-black hover:bg-gray-50'
              }`}
            >
              Properties
            </NavLink>
            <NavLink 
              onClick={() => setIsOpen(false)} 
              to="/contact" 
              className={({ isActive }) => `px-4 py-3 rounded-lg font-medium text-sm tracking-wide transition-all duration-200 ${
                isActive 
                  ? 'bg-prose-brand/10 text-prose-brand font-bold' 
                  : 'text-prose-black hover:bg-gray-50'
              }`}
            >
              Contact
            </NavLink>
            
            <NavLink 
              onClick={() => setIsOpen(false)}
              to="/contact"
              className="mt-3 flex items-center justify-center gap-2 px-5 py-2.5 bg-prose-brand text-white rounded-lg font-medium text-sm tracking-wide hover:bg-prose-brand/90 transition-all duration-300"
            >
              <MessageSquare size={17} />
              Get in Touch
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;